// extracted by mini-css-extract-plugin
export var legendIndicator = "_fv-1";
export var legendRight = "_fv-0";